import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettings, IPageContent} from '@app/feature/store-editor/components/layout/store-editor.interface';

@Component({
  selector: 'app-text-setting',
  templateUrl: './text-setting.component.html',
  styleUrls: ['../styling/styling.component.css']
})
export class TextSettingComponent implements OnInit {

  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;
  constructor() { }

  ngOnInit() {
  }

}
